


















































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Recipient from './Recipient.vue'
import {IRecipient} from '@/entities/notices'
import Spinner from 'vue-simple-spinner'
import Fuse from 'fuse.js'
import {Getter} from "vuex-class"
import SearchBar from '@/components/Rain/Inputs/SearchBar.vue'
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import SelectedRecipientPills from "./SelectedRecipientPills.vue";
import BaseButton from "@/components/Rain/Buttons/BaseButton.vue";

@Component<RecipientPicker>({
    components: { BaseButton, SelectedRecipientPills, Tab, Tabs, Recipient, Spinner, SearchBar}
})
export default class RecipientPicker extends Vue {

    @Prop(Array) private recipients !: IRecipient[]
    @Prop(Array) private selectedRecipients !: IRecipient[]
    @Prop({type: Boolean, default: false}) public canPickVirtualUsers!: boolean
    // if compact, no border bottom, padding also smaller
    @Prop({type: Boolean, default: false}) private compact !: boolean
    // Number of recipients to show initially without search
    @Prop({ type: Number, required: false }) private maxListLength!: number

    private searchText = ''

    @Getter private virtualUsers!: IRecipient[]

    private get filteredRecipients() {
        if (this.searchText.length > 2) {
            return this.fuse.search(this.searchText)
        }
        if (this.maxListLength && this.maxListLength < this.recipients.length) {
            return this.recipients.slice(0, this.maxListLength)
        }
        return this.recipients
    }

    private get filteredVirtualUsers() {
        if (this.searchText.length > 2) {
            return this.fuseVirtual.search(this.searchText)
        }
        if (this.maxListLength && this.maxListLength < this.virtualUsers.length) {
            return this.virtualUsers.slice(0, this.maxListLength)
        }
        return this.virtualUsers
    }

    private get fuse() {
        return new Fuse(this.recipients, {
            keys: ['name', 'id', 'type'],
            shouldSort: true,
            threshold: 0.4,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 3
        })
    }

    private get fuseVirtual() {
        return new Fuse(this.virtualUsers, {
            keys: ['name', 'id', 'type'],
            shouldSort: true,
            threshold: 0.4,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 3
        })
    }

    private clearSelectedRecipients() {
        this.searchText = ''
        this.$emit('clearSelectedRecipients')
    }

    private selectRecipient(recipient: IRecipient) {
        let updatedRecipients = [...this.selectedRecipients]
        const everyoneSelected = updatedRecipients.find((selectedRecipient) => {
            return selectedRecipient.name === 'Everyone'
        });

        if (this.isRecipientSelected(recipient) ) {
            //remove selected
            updatedRecipients.splice(this.getSelectedRecipientIndex(recipient), 1)
        } else {
            // Removes everyone off the list if 'Everyone' is selected
            // or removes 'Everyone' if an individual or group is selected.
            everyoneSelected || recipient.name === 'Everyone'
                ? updatedRecipients = [recipient]
                : updatedRecipients.push(recipient);
        }
        this.$emit('toggleRecipient', updatedRecipients, recipient)
    }

    private isRecipientSelected(recipient: IRecipient) {
        return this.getSelectedRecipientIndex(recipient) >= 0
    }

    private getSelectedRecipientIndex(recipient: IRecipient) {
        let index = -1
        this.selectedRecipients.forEach(
            (r, i) =>{
                if(
                    (r.type !== 'user' || r.user_id === recipient.user_id) &&
                    r.field === recipient.field &&
                    r.type === recipient.type &&
                    r.role === recipient.role &&
                    r.value === recipient.value) {
                        index = i;
                    }
                })
        return index
    }
}
